import { render } from "./CreateImkpModal.vue?vue&type=template&id=59172949"
import script from "./CreateImkpModal.vue?vue&type=script&lang=js"
export * from "./CreateImkpModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__